export default "__VITE_ASSET__BHOMpppI__"